import { type TranslationTree } from '@/i18n/types';

export const messages = {
  tabs: {
    all: 'Todas',
    draft: 'Rascunhos',
    in_review: 'Em análise',
    changes_requested: 'Ajuste pedido',
    approved: 'Aprovadas',
    rejected: 'Recusadas',
    archived: 'Arquivadas',
  },
  status: {
    draft: 'Rascunho',
    in_review: 'Em análise',
    changes_requested: 'Ajuste pedido',
    approved: 'Aprovada',
    rejected: 'Recusada',
    archived: 'Arquivada',
  },
  actionKind: {
    link: 'Site ou loja online',
    whatsapp: 'WhatsApp',
    phone: 'Telefone',
    lead: 'Receber contatos (com consentimento)',
    directions: 'Como chegar',
  },
  actionHint: {
    link: 'Abre o seu site. Com cupom, o app copia o código antes',
    whatsapp: 'Abre uma conversa já com a mensagem',
    phone: 'Liga para o seu número',
    lead: 'O atleta aceita compartilhar nome, e-mail e telefone',
    directions: 'Abre o mapa até o endereço da oferta',
  },
  actionDefault: {
    link: 'Ir para o site',
    whatsapp: 'Chamar no WhatsApp',
    phone: 'Ligar',
    lead: 'Quero ser contatado',
    directions: 'Como chegar',
  },
  actionShort: {
    link: 'Site',
    whatsapp: 'WhatsApp',
    phone: 'Telefone',
    lead: 'Contatos',
    directions: 'Como chegar',
  },
  coupon: 'Cupom',
  preset: {
    onlineCoupon: 'Cupom para loja online',
    storeCoupon: 'Loja física com cupom',
    whatsappBooking: 'Agendar pelo WhatsApp',
    leads: 'Receber contatos',
  },
  whatsappDefaultMessage: 'Olá! Vi a oferta "{{title}}" no Bodyprint.',
  whatsappDefaultTitle: 'título da oferta',
  campaign: {
    approved: 'Aprovada',
    live: 'No ar',
    paused: 'Pausada',
    ended: 'Encerrada',
  },
  campaignSummary: {
    liveUntil: 'No ar até {{date}}',
    startsAt: 'Começa em {{date}}',
  },
  period: {
    from: 'A partir de {{date}}',
    until: 'Até {{date}}',
  },
} satisfies TranslationTree;
